import type { ProjetoSalvo } from '../types/corte';
import {
  contarProjetosCatalogo,
  gravarLegadoCatalogoLocalStorage,
  mesclarEstadoCatalogo,
  mesclarProjetosCatalogo,
} from './adePersistenciaCatalogo';
import catalogoMigradoArquivo from '../data/catalogo-migrado.json';

const STORE_KEY = 'planos-corte-ade';
const ZUSTAND_VERSION = 0;

export interface CatalogoMigradoPayload {
  migradoEm?: string;
  origem?: string;
  projetosSalvos: ProjetoSalvo[];
}

/** Backup embutido no build — funciona em file:// (NW.js) sem fetch. */
export function projetosDoBackupEmbutido(): ProjetoSalvo[] {
  const payload = catalogoMigradoArquivo as CatalogoMigradoPayload;
  if (!Array.isArray(payload?.projetosSalvos)) return [];
  return payload.projetosSalvos.filter(
    (p) => p && typeof p.nomeProduto === 'string' && Array.isArray(p.pecas)
  );
}

export function catalogoMigradoParaZustand(projetos: ProjetoSalvo[]): string {
  return JSON.stringify({
    state: {
      projetosSalvos: projetos,
      configuracao: { larguraTotal: 2200, comprimentoTotal: 2750, espessuraSerra: 4 },
      materialConfig: { tipoMaterial: 'aglomerado', espessuraMaterial: 15 },
    },
    version: ZUSTAND_VERSION,
  });
}

/** Tenta fetch (dev/http); senão usa JSON embutido. */
export async function carregarCatalogoMigrado(): Promise<ProjetoSalvo[]> {
  const embutido = projetosDoBackupEmbutido();
  if (typeof fetch === 'undefined') return embutido;

  try {
    const resp = await fetch('./catalogo-migrado.json', { cache: 'no-store' });
    if (resp.ok) {
      const data = (await resp.json()) as CatalogoMigradoPayload;
      if (Array.isArray(data.projetosSalvos) && data.projetosSalvos.length > 0) {
        return mesclarProjetosCatalogo(embutido, data.projetosSalvos);
      }
    }
  } catch {
    /* file:// ou offline */
  }
  return embutido;
}

export function mesclarComCatalogoMigradoSync(...fontes: (string | null)[]): string | null {
  const embutido = projetosDoBackupEmbutido();
  const migradoJson = embutido.length ? catalogoMigradoParaZustand(embutido) : null;
  return mesclarEstadoCatalogo(...fontes, migradoJson);
}

export async function mesclarComCatalogoMigrado(
  ...fontes: (string | null)[]
): Promise<string | null> {
  const migrado = await carregarCatalogoMigrado();
  const migradoJson = migrado.length ? catalogoMigradoParaZustand(migrado) : null;
  return mesclarEstadoCatalogo(...fontes, migradoJson);
}

export function persistirCatalogoMesclado(valor: string): void {
  gravarLegadoCatalogoLocalStorage(STORE_KEY, valor);
}

export { mesclarProjetosCatalogo, STORE_KEY as CATALOGO_STORE_KEY };
